import React from 'react';
import Konva from 'konva';
import useDraggingNodeId from 'components/canvas/hooks/use-dragging-node-id';

export function useNodeContextMenuAnimation(
  node,
): React.RefObject<Konva.Group> {
  const elementRef = React.useRef<any>(null);
  const [draggingNodeId] = useDraggingNodeId();
  const [isDragged, setIsDragged] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (elementRef.current) {
      const isThisNodeDragged = draggingNodeId === node.id;

      if (isThisNodeDragged) {
        setIsDragged(true);

        if (!elementRef.current.tween) {
          elementRef.current.tween = new Konva.Tween({
            node: elementRef.current,
            duration: 0.1,
            opacity: 0,
          });
        }

        elementRef.current.tween.play();
      } else if (isDragged && !isThisNodeDragged && elementRef.current.tween) {
        setIsDragged(false);
        elementRef.current.tween.reverse();
      }
    }
  }, [draggingNodeId, node.id, isDragged]);

  return elementRef;
}
